import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Row,
  Col,
  Label,
  Card
} from "reactstrap"
import i18n from "../../../i18n"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import * as Yup from 'yup';
import { useFormik } from "formik";
import { delEmployeesAdminImportDelete, postEmployeesAdminImport, putEmployeesAdminStatus, getTempleatesEmployeesAdmin } from "../../../helpers/api_rombo_helper";
import SimpleAlertError from '../../../components/Alerts/SimpleAlertError'
import { useEffect } from "react"
import Select from "react-select";
import config from '../../../constants/settings'

const AdminModal = (props) => {

  const { isOpen, toggle, setAdminModal, setShowAlertSuccess, setTextHeader, setTextBody, setReloadEmployee,
    reloadEmployee, token, infoUser, listCompanies } = props;

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [company, setCompany] = useState({});
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  useEffect(() => {
    setErrorAlert(false);
  }, [reloadEmployee]);
  
  useEffect(() => {
    fillCompany()
  }, [infoUser]);

  const autoformik = useFormik({
    initialValues: {
      action: "CREATE_EMPLOYEES",
      fileType: "csv"
    },
    validationSchema: Yup.object({
      action: Yup.string(),
      fileType: Yup.string()
    })
  });

  useEffect(() => {
    onGetTempleatesEmployeesAdmin();
  }, [autoformik.values.action]);

  const fillCompany = () => {
    if (!infoUser.is_staff) {
      setCompany({
        label: infoUser.partner_name,
        value: infoUser.partner_id,
      });
    }
  };  

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    )
    setSelectedFiles(files)
  }

  const clickCancel = () => {
    setAdminModal(false);
    setErrorAlert(false);
    (infoUser.is_staff) && setCompany({})
    setSelectedFiles([])
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const onGetTempleatesEmployeesAdmin = (type_file) => {
    let hrefLink = ""
    switch(autoformik.values.action){
      case "CREATE_EMPLOYEES":
        type_file == "csv" ? hrefLink = config.templates.employees.createCsv : hrefLink = config.templates.employees.createXlsx
        break;
      case "DELETE_EMPLOYEES":
        type_file == "csv" ? hrefLink = config.templates.employees.deleteCsv : hrefLink = config.templates.employees.deleteXlsx
        break;
      case "ACTIVE_EMPLOYEES":
        type_file == "csv" ? hrefLink = config.templates.employees.activeCsv : hrefLink = config.templates.employees.activeXlsx
        break;
      case "INACTIVE_EMPLOYEES":
        type_file == "csv" ? hrefLink = config.templates.employees.inactiveCsv : hrefLink = config.templates.employees.inactiveXlsx
        break;
    }
    return hrefLink;
  }

  function onClickSave() {
    let options = {}
    const formData = new FormData();
    formData.append("action", autoformik.values.action);
    formData.append("type_file", autoformik.values.fileType);
    if(infoUser.is_staff) options = {company_id: company.value, company_name: company.label}
    formData.append("file", selectedFiles[0]);
    switch (autoformik.values.action) {
      case "CREATE_EMPLOYEES":
        if(infoUser.is_staff) options = {partner_id: company.value, partner_name: company.label}
        postEmployeesAdminImport(token, formData, options)
          .then((response) => {
            setSelectedFiles([]);
            setAdminModal(false);
            setShowAlertSuccess(true);
            setReloadEmployee(!reloadEmployee);
            setTextHeader(i18n.t("EmployeeImport", { number: response.length }));
            setTextBody(i18n.t("SuccessAdminEmployees", { format: autoformik.values.fileType }));
          })
          .catch((error) => {
            console.error("Error - postEmployeesAdminImport ", error);
            setErrorAlertMessage(error.response.data.detail ||= error.message);
            setErrorAlert(true);
            setSelectedFiles([]);
          });
        break;

      case 'DELETE_EMPLOYEES':
        delEmployeesAdminImportDelete(token, formData, options)
          .then((response) => {
            setSelectedFiles([]);
            setAdminModal(false);
            setShowAlertSuccess(true);
            setReloadEmployee(!reloadEmployee);
            setTextHeader(i18n.t("EmployeeImportDelete"));
            setTextBody(i18n.t("SuccessAdminEmployees", { format: autoformik.values.fileType }));
          })
          .catch((error) => {
            console.error("Error - delEmployeesAdminImportDelete ", error);
            setErrorAlertMessage(error.response.data.detail ||= error.message);
            setErrorAlert(true);
            setSelectedFiles([]);
          });
        break;
      case 'INACTIVE_EMPLOYEES':
        putEmployeesAdminStatus(token, 'INACTIVE', formData, options)
          .then((response) => {
            setSelectedFiles([]);
            setAdminModal(false);
            setShowAlertSuccess(true);
            setReloadEmployee(!reloadEmployee);
            setTextHeader(i18n.t("EmployeeImport", { number: response.length }));
            setTextBody(i18n.t("SuccessAdminEmployees", { format: autoformik.values.fileType }));
          })
          .catch((error) => {
            console.error("Error - putEmployeesAdminStatus ", error);
            setErrorAlertMessage(error.response.data.detail ||= error.message);
            setErrorAlert(true);
          });
        break;
      case 'ACTIVE_EMPLOYEES':
        putEmployeesAdminStatus(token, 'ACTIVE', formData, options)
          .then((response) => {
            setSelectedFiles([]);
            setAdminModal(false);
            setShowAlertSuccess(true);
            setReloadEmployee(!reloadEmployee);
            setTextHeader(i18n.t("EmployeeImport", { number: response.length }));
            setTextBody(i18n.t("SuccessAdminEmployees", { format: autoformik.values.fileType }));
          })
          .catch((error) => {
            console.error("Error - putEmployeesAdminStatus ", error);
            setErrorAlertMessage(error.response.data.detail ||= error.message);
            setErrorAlert(true);
            setSelectedFiles([]);
          });
        break;
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <div className="modal-header-container">
          <p className="cancellation-title modal-header-bottom">
            {i18n.t("AdminEmployees")}
          </p>
        </div>
        <div className="modal-separator" />
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert} text={errorAlertMessage} />
          <Row>
            <Form className="row gy-2 gx-3 align-items-center">
              {infoUser.is_staff && (
                <>
                  <Col xxl={12} md={12} xs={12}>
                    <Label className="employees-modal-subtitle">{i18n.t("Partner")}</Label>
                    <Card className="mb-1">
                      <Select
                        name="company"
                        placeholder={i18n.t("SelectPartnerName")}
                        options={listCompanies}
                        className="select2-selection"
                        onChange={(e) => {
                          setCompany(e);
                        }}
                      />
                    </Card>
                  </Col>
                  <div className="modal-separator" />
                </>
              )}
              <Col xs={12} xl={12} md={12}>
                <Label className="employees-modal-subtitle">{i18n.t("Action")}</Label>
                <div className="btn-group col-12" role="group">
                  <input type="radio"
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    className="btn-check"
                    name="action"
                    id="import"
                    value="CREATE_EMPLOYEES"
                    autoComplete="off"
                    defaultChecked />
                  <label className="z-0 btn btn-outline-primary border-0" htmlFor="import">
                    {i18n.t("Import")}
                  </label>
                  <input type="radio"
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    className="btn-check"
                    name="action"
                    id="eliminated"
                    value="DELETE_EMPLOYEES"
                    autoComplete="off"
                    />
                  <label className="z-0 btn btn-outline-primary border-0" htmlFor="eliminated">
                    {i18n.t("Eliminated")}
                  </label>
                  <input type="radio"
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    className="btn-check"
                    name="action"
                    id="actived"
                    value="ACTIVE_EMPLOYEES"
                    autoComplete="off"
                    />
                  <label className="z-0 btn btn-outline-primary border-0" htmlFor="actived">
                    {i18n.t("Actived")}
                  </label>
                  <input type="radio"
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    className="btn-check"
                    name="action"
                    id="inactived"
                    value="INACTIVE_EMPLOYEES"
                    autoComplete="off"
                    />
                  <label className="z-0 btn btn-outline-primary border-0" htmlFor="inactived">
                    {i18n.t("Inactived")}
                  </label>
                </div>
              </Col>
              <div className="modal-separator" />
              {/* <Col xs={12} xl={12} md={12}>
                <p>{i18n.t("FileType")}</p>
                <div className="btn-group col-12" role="group">
                  <input type="radio"
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    className="btn-check"
                    name="fileType"
                    id="csv"
                    value="csv"
                    autoComplete="off"
                    defaultChecked />
                  <label className="z-0 btn btn-outline-primary border-0" htmlFor="csv">{i18n.t("Csv")}</label>

                  <input type="radio"
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    className="btn-check"
                    name="fileType"
                    id="xlsx"
                    value="xlsx"
                    autoComplete="off"
                    />
                  <label className="z-0 btn btn-outline-primary border-0" htmlFor="xlsx">{i18n.t("Xlsx")}</label>
                </div>
              </Col> */}
              <Col xs={12} xl={12} md={12}>
                <Label className="employees-modal-subtitle">{i18n.t("Template")}</Label>
                <p>{i18n.t("TextTemplate")}</p>
                <div className="btn-group col-12" role="group">
                  <a href={onGetTempleatesEmployeesAdmin("csv")} className="btn btn-outline-success border-0" target="_blank">
                    {i18n.t("TemplateCsv")}
                  </a>
                  <a href={onGetTempleatesEmployeesAdmin("xlsx")} className="btn btn-outline-success border-0" target="_blank">
                    {i18n.t("TemplateXls")}
                  </a>
                </div>
              </Col>
              <div className="modal-separator" />
              <p/>
              <Dropzone
                accept={{ 'text/*': ['.csv', '.xlsx'] }}
                onDrop={acceptedFiles => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-3">
                        {selectedFiles.length !== 0
                          ? <i className="display-4 text-success bx bx-check-circle" />
                          : <i className="display-4 text-muted bx bxs-cloud-upload" />
                        }
                      </div>
                      {selectedFiles.length !== 0 ? "" : <h4>{i18n.t("TextDragFile")}</h4>}
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="shadow-none dz-processing dz-image-preview dz-complete"
                            key={`${i}-file`}
                          >
                            <Row className="align-items-center">
                              <Col>
                                <Link
                                  to="#"
                                  className="text-muted"
                                >
                                  <h5><strong>{f.name}</strong></h5>
                                </Link>
                                <p className="mb-0 text-success">
                                  <h5><span>{f.formattedSize}</span></h5>
                                </p>
                              </Col>
                            </Row>
                          </Card>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Dropzone>
            </Form>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            disabled={!company.value || !selectedFiles.length == 1}
            onClick={onClickSave}
          >
            {i18n.t("Save")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={() => clickCancel()}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

AdminModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setAdminModal: PropTypes.func,
  setReloadEmployee: PropTypes.func,
  reloadEmployee: PropTypes.bool,
  setShowAlertSuccess: PropTypes.func,
  setTextHeader: PropTypes.func,
  token: PropTypes.object,
  setTextBody: PropTypes.func
}

export default AdminModal;
